import Vue from 'vue'

/**
 * Util for parsing prefix and phone number when in a single string
 * @name Parse phone number
 * @returns {string} parsed value
 */

const parsePhoneNumber = (value, replaceValue = '') => {
  return value.split('//').join(replaceValue)
}

Vue.filter('parsePhoneNumber', parsePhoneNumber)

export default parsePhoneNumber
